const legalEntityMoreInformationSchema = {
  registrationStatus: {
    displayName: 'Situação cadastral',
    type: 'boolean',
    notAvailable: 'Não informado',
    mask: 'registrationStatus',
  },
  registrationStatusReason: {
    displayName: 'Motivo da situação cadastral',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  size: {
    displayName: 'Porte da empresa',
    type: 'string',
    notAvailable: 'Não informado',
    mask: 'companySize',
  },
  isSimples: {
    displayName: 'É Simples Nacional',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  isMei: {
    displayName: 'É MEI',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  capital: {
    displayName: 'Capital social',
    type: 'boolean',
    notAvailable: 'Não informado',
    mask: 'currency',
  },
}

export default legalEntityMoreInformationSchema
